import React from "react";
import "../styles/loader-styles.css";

function Loader() {
  return (
    <div className="loader-container">
      <div className="shapes"></div>
    </div>
  );
}

export default Loader;
